export function momentum(answers) {
  const C1 = answers.C1 || 0;
  const C2 = answers.C2 || 0;
  const V2 = answers.V2 || 0;
  return C1 * 0.4 + C2 * 0.3 + V2 * 0.3;
}
